import type { ReactNode } from 'react';

/**
 * Icones da navegacao, iguais aos dos mockups.
 *
 * Inline em SVG e nao via biblioteca: sao sete, mudam pouco, e assim nao ha
 * requisicao extra nem pacote de icones no bundle.
 */
const svg = (children: ReactNode): ReactNode => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    {children}
  </svg>
);

export const IconOverview = (): ReactNode =>
  svg(
    <>
      <rect x="3" y="3" width="8" height="8" rx="1.5" />
      <rect x="13" y="3" width="8" height="8" rx="1.5" />
      <rect x="3" y="13" width="8" height="8" rx="1.5" />
      <rect x="13" y="13" width="8" height="8" rx="1.5" />
    </>,
  );

export const IconDocs = (): ReactNode =>
  svg(
    <>
      <path d="M6 3h8l4 4v14H6z" />
      <path d="M14 3v4h4M9 12h6M9 16h6" />
    </>,
  );

export const IconClock = (): ReactNode =>
  svg(
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7v5l3 2" />
    </>,
  );

export const IconBuilding = (): ReactNode => svg(<path d="M3 21h18M5 21V8l7-4 7 4v13M9 21v-6h6v6" />);

export const IconCode = (): ReactNode => svg(<path d="M8 7l-5 5 5 5M16 7l5 5-5 5M14 4l-4 16" />);

export const IconTeam = (): ReactNode =>
  svg(
    <>
      <circle cx="9" cy="8" r="3.5" />
      <path d="M2.5 20a6.5 6.5 0 0 1 13 0M16 4.5a3.5 3.5 0 0 1 0 7M21.5 20a6.5 6.5 0 0 0-4-6" />
    </>,
  );

export const IconCard = (): ReactNode =>
  svg(
    <>
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="M3 10h18M7 15h4" />
    </>,
  );

export const IconPulse = (): ReactNode => svg(<path d="M3 12h4l3-8 4 16 3-8h4" />);

export const IconShield = (): ReactNode =>
  svg(
    <>
      <path d="M12 3l7 3v6c0 4.5-3 8-7 9-4-1-7-4.5-7-9V6z" />
      <path d="M9 12l2 2 4-4" />
    </>,
  );

export const IconTable = (): ReactNode =>
  svg(
    <>
      <rect x="3" y="4" width="18" height="16" rx="2" />
      <path d="M3 9h18M9 9v11" />
    </>,
  );

export const IconQueue = (): ReactNode =>
  svg(
    <>
      <path d="M4 6h16M4 12h16M4 18h10" />
    </>,
  );

export const IconAlert = (): ReactNode =>
  svg(
    <>
      <path d="M12 4l9 16H3z" />
      <path d="M12 10v4M12 17h.01" />
    </>,
  );

/**
 * Marca do produto.
 *
 * Era a sigla "FA" num quadrado. Sigla nao diz o que a empresa faz, e esta
 * faz uma coisa muito concreta: nota fiscal.
 *
 * O desenho e um documento com a borda de baixo serrilhada — o recorte do
 * cupom, que ja e o elemento memoravel do hero da landing, reduzido ao
 * tamanho de favicon. As tres linhas internas sao itens e total; a ultima e
 * mais curta porque total nunca ocupa a largura inteira.
 *
 * Mesmo traco dos icones de navegacao (1.8), para a marca nao destoar da
 * barra lateral onde fica a dois centimetros deles.
 */
export const IconNota = (): ReactNode => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M5 20.4V4.6A.6.6 0 0 1 5.6 4h12.8a.6.6 0 0 1 .6.6v15.8l-2.3-1.6-2.3 1.6-2.3-1.6-2.3 1.6-2.3-1.6z" />
    <path d="M8.6 8.6h6.8M8.6 12h6.8M8.6 15.4h3.6" />
  </svg>
);
